import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { ApiConnectionEndpoint } from '../constants/api-connection-endpoint';
import { ApiConnectionBrief, ApiConnectionListSearchCriteria } from '../models';
import { getQueryStringFromObject } from '../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class ApiConnectionListService {
  constructor(private http: WrapperHttpService) {}

  getApiConnectionList({
    page,
    size,
    ...filterView
  }: ApiConnectionListSearchCriteria): Observable<ApiConnectionBrief[]> {
    const url = `${API_URL}${ApiConnectionEndpoint.Base}${ApiConnectionEndpoint.Search}${
      filterView
        ? `?${getQueryStringFromObject({
            page,
            size,
          })}`
        : ''
    }`;
    return this.http.withLoading().post<ApiConnectionBrief[]>(url, { ...filterView });
  }
}
